import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { MasterTaskBuilder } from '../../models/builders/master-task.builder';
import { MasterTask } from '../../models/master-task';
import { MasterTaskTool } from '../../models/master-task-tool';
import { mapCollection } from '../../utils/collection.utils';
import { MasterTaskToolBuilder } from '../../models/builders/master-task-tool.builder';

const createMasterTaskToolBody = (masterTaskTool: MasterTaskTool) => ({
  hash: masterTaskTool.hash,
  tool: masterTaskTool.tool,
  toolHolder: masterTaskTool.toolHolder,
  length: masterTaskTool.length,
  markedToSend: masterTaskTool.markedToSend
});

const createMasterTaskBody = (masterTask: MasterTask) => ({
  identifier: masterTask.identifier,
  name: masterTask.name,
  hash: masterTask.hash,
  tools: mapCollection(masterTaskTool => createMasterTaskToolBody(masterTaskTool), masterTask.masterTaskTools),
  adapter: masterTask.adapter
});

@Injectable()
export class MasterTaskApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }master-tasks`;
  }

  createMasterTask(task: MasterTask) {
    return this.httpClient.post(`${ this.apiUrl }`, createMasterTaskBody(task))
      .pipe(
        map(MasterTaskBuilder.fromJson)
      );
  }

  deleteMasterTask(task: MasterTask) {
    return this.httpClient.delete(`${ this.apiUrl }/${ task.hash }`);
  }

  getMasterTask(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(MasterTaskBuilder.fromJson));
  }

  getMasterTasks() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(MasterTaskBuilder.fromList));
  }

  getMasterTaskSuggestions(modelHash: string) {
    const params = new HttpParams()
      .append('model', modelHash);

    return this.httpClient.get(`${ this.apiUrl }/suggestions`, { params }).pipe(map(MasterTaskBuilder.fromList));
  }

  updateMasterTask(task: MasterTask) {
    return this.httpClient.put(`${ this.apiUrl }/${ task.hash }`, createMasterTaskBody(task))
      .pipe(
        map(MasterTaskBuilder.fromJson)
      );
  }

  sendZollerMasterTask(hash: string) {
    return this.httpClient.post(`${ this.apiUrl }/${ hash }/zoller`, '')
      .pipe(
        map(MasterTaskBuilder.fromJson)
      );
  }

  sendHaimerMasterTask(hash: string) {
    return this.httpClient.post(`${ this.apiUrl }/${ hash }/haimer`, '')
      .pipe(
        map(MasterTaskBuilder.fromJson)
      );
  }

  getMasterTaskToolSuggestions(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }/master-task-tools`).pipe(map(MasterTaskToolBuilder.fromList));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/master-task-api.service.ts